export default (paramName) => {
    let urlObj = new URL(window.location.href);
    let searchParams = new URLSearchParams(urlObj.search)

    if (searchParams.has(paramName)) {
        searchParams.delete(paramName);
        urlObj.search = searchParams.toString()
        history.replaceState(null, null, urlObj.toString())
    }
}